import { ArrowUpRight } from "lucide-react";
import { Overline, Reveal } from "./Primitives";
import { useT } from "@/lib/i18n";
import { scrollToId } from "@/lib/scroll";

export const Services = () => {
  const t = useT().services;
  return (
    <section id="services" className="py-24 md:py-36 bg-[var(--bg2)]">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <Reveal>
          <Overline>{t.over}</Overline>
          <h2 className="mt-6 font-display font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight max-w-3xl">{t.title}</h2>
        </Reveal>
        <div className="mt-16 md:mt-24 border-t border-[var(--line)]">
          {t.items.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.1}>
              <button
                data-testid={`service-row-${i}`}
                onClick={() => scrollToId("pricing")}
                className="service-row group w-full text-left grid md:grid-cols-12 gap-6 py-10 md:py-14 border-b border-[var(--line)] items-start"
              >
                <span className="md:col-span-1 font-mono text-sm text-[var(--gold)]">{s.n}</span>
                <h3 className="md:col-span-5 font-display text-4xl md:text-6xl font-light leading-none transition-transform duration-500 group-hover:translate-x-3">{s.t}</h3>
                <div className="md:col-span-5">
                  <p className="text-stone-300 leading-relaxed">{s.d}</p>
                  <div className="mt-5 flex flex-wrap gap-2">
                    {s.tags.map((tag) => (
                      <span key={tag} className="text-xs font-mono px-3 py-1.5 rounded-full border border-[var(--line)] text-stone-300">{tag}</span>
                    ))}
                  </div>
                </div>
                <span className="hidden md:grid md:col-span-1 justify-self-end w-14 h-14 rounded-full border border-[var(--line)] place-items-center transition-colors duration-500 group-hover:bg-[var(--gold)] group-hover:text-[#0c0a09]">
                  <ArrowUpRight size={20} className="transition-transform duration-500 group-hover:rotate-45" />
                </span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
